<div class="page-content-container">
	<div class="page-content">
		<h3 class="header-text header-margin-bottom" i18n="@@addClientConfirmation-confirmation">Confirmation</h3>
		<mat-divider></mat-divider>

		<p class="confirmation-message" i18n="@@addClientConfirmation-message">
			This is a confirmation that the following client has been added:
		</p>

		<div class="confirmation-details">
			<p class="client-name">
				<span data-automation-id="confirmation-client-name">{{ editClient.firstName }} {{ editClient.lastName }}</span>
				<span class="client-id">
					<span>(</span><span i18n="@@addClientConfirmation-clientIdLabel">Client ID:</span
					><span data-automation-id="confirmation-client-idn">{{ ' ' }}{{ editClient.idn }}</span
					><span>)</span>
				</span>
			</p>

			@if (propertyDetails) {
				<p class="property-info">
					<strong i18n="@@addClientConfirmation-property">Property:</strong>
					<span data-automation-id="confirmation-property-name">{{ ' ' }}{{ propertyDetails.name }}</span>
				</p>
			}

			@if (propertyDetails) {
				<p class="address-info">
					<strong i18n="@@addClientConfirmation-address">Address:</strong>
					<span data-automation-id="confirmation-property-address">{{ ' ' }}{{ formatAddress() }}</span>
				</p>
			}
		</div>

		<div class="button-container">
			<button
				class="primary-small-button"
				(click)="onReturnToClientsClick()"
				data-automation-id="return-to-clients-button"
			>
				{{ getReturnButtonText() }}
			</button>
			<button
				class="secondary-small-button"
				i18n="@@addClientConfirmation-addAnotherButton"
				(click)="onAddAnotherClientClick()"
				data-automation-id="add-another-client-button"
			>
				+ Add Another Client
			</button>
		</div>
	</div>
</div>
